import React from "react"
import { Global, css } from "@emotion/core"
import { ThemeProvider } from "emotion-theming"
import Theme from "./src/themes/theme"

export const wrapRootElement = ({ element }) => (
  <ThemeProvider theme={Theme}>
    <Global
      styles={css`
        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }
        html,
        body {
          font-family: "Muli", sans-serif;
        }
        table {
          border-collapse: collapse;
          border: 1px solid rgb(161, 162, 165);
          width: 100%;
          border-spacing: 0.25rem;
          border-collapse: collapse;
          font-size: 1rem;
          line-height: 1.5rem;
          font-weight: 400;
        }
        table th {
          text-align: left;
          background: #3a5559;
          color: #fff;
          font-weight: 700;
          padding: 20px 10px;
        }
        table td {
          border: 1px solid #e3e3e3;
          text-align: left;
          padding: 20px 20px;
        }
      `}
    />
    {element}
  </ThemeProvider>
)
